<div class="add-business-info">
  <div class="add-business-info__notification" [mmTestTarget]="'fill-to-validate'">
    <mm-alert [alertConfig]="alertConfig"></mm-alert>
  </div>

  <div class="add-business-info__form">
    <app-advanced-form [config]="advancedFormConfig$ | async"
                       (events)="onAdvancedFormEvents($event)"
                       [mmTestId]="'ADD_BUSINESS_INFO_PAGE.FORM'"></app-advanced-form>
  </div>

  <div class="add-business-info__footer">
    {{ 'PAGES.ACCOUNT.INFO.ADD_BUSINESS_INFO.FOOTER.TEXT' | translate }}
  </div>
</div>
